module.exports = __webpack_public_path__ + "img/business-bg.c97ec615.jpg";